var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('db-col',{staticClass:"tabbar-wrapper",attrs:{"height":_vm.height,"valign":"middle"}},[_vm._t("prefix"),_vm._l((_vm.navs),function(nav,idx){return _c('db-tabbar-item',{key:idx,attrs:{"value":_vm.value,"nav":nav}})}),_vm._t("suffix")],2)}
var staticRenderFns = []

export { render, staticRenderFns }